// extracted by mini-css-extract-plugin
module.exports = {"player":"AudioPlayer_player__oOEGj"};